import { composeIncludeString } from '../api-utilities/compose-include-string';
import { AreaProjectModel, areaProjectQuery } from '../generated';

const INCLUDED_PROPERTIES = <const>[
    'name',
    'image',
    'url',
    'shortDescription',
    'isCompleted',
    'location',
    'geometry',
];

interface AreaProjectEssentials
    extends Pick<AreaProjectModel, 'id' | typeof INCLUDED_PROPERTIES[number]> {
    objectType: 'areaProject';
}

/**
 * @description Returns an array of all areaProjects extended.
 * @return {*}  {Promise<ExtendedAreaProject[]>}
 */
const getAreaProjectsLightweight = async (): Promise<AreaProjectEssentials[]> => {
    const areaProjects = (await areaProjectQuery({
        include: composeIncludeString([...INCLUDED_PROPERTIES]),
    })) as AreaProjectEssentials[];

    areaProjects.forEach((areaProject) => {
        areaProject.objectType = 'areaProject';
    });

    return areaProjects;
};

export { getAreaProjectsLightweight };
